module.exports = __webpack_public_path__ + "media/Video 110.f11c8e59.mp4";